export default __webpack_public_path__ + "static/media/add.0efd9f67.svg";